import React, { useState, useEffect } from "react";
import Logo from "../home/img/banner/b30.png";
import { MdEmail } from "react-icons/md";
import { FaMapMarkedAlt } from "react-icons/fa";
import { IoCall, IoTime } from "react-icons/io5";
import { ToastContainer, toast } from "react-toastify";
import Swal from "sweetalert2";
import Loader from "../home/Loader";
import "./about.css";
import PageTitle from "../store/PageTitle";
import { useSelector, useDispatch } from "react-redux";
import { fetchFooter } from "../store/action/contentAction";

const serverUrl = process.env.REACT_APP_SERVER_URL;

function Contact() {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  // Handle input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await fetch(`${serverUrl}/api/send-email`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Received Successfully!",
          text: "Email Received Successfully, will get back to you in sec!",
          confirmButtonText: "Okay",
        });

        setFormData({ name: "", email: "", subject: "", message: "" });
      } else {
        toast.error("Failed to send message.");
      }
    } catch (error) {
      console.error("Error sending message:", error);
      toast.error("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  const handleSoon = () => {
    Swal.fire({
      icon: "warning",
      title: "Coming Soon",
      text: "Newsletter will be available soon",
      confirmButtonText: "Okay",
    });
  };

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchFooter());
  }, [dispatch]);

  const footerData = useSelector((state) => state.footer.data) || [];

  return (
    <div>
      <PageTitle title="Contact Us" />
      <section id="page-header" className="contact-header">
        <h2>#letsTalk</h2>
        <p>Leave a Message. We Love to Hear From You</p>
      </section>
      <section id="contact-details" className="section-pl">
        {footerData.map((item) => (
          <div className="details">
            <span>GET IN TOUCH</span>
            <h2>Visit any of our locations or contact us today</h2>
            <h3> Our Shops</h3>
            <div>
              <li>
                <i className="fa fa-map">
                  <FaMapMarkedAlt />
                </i>
                <p>{item.address_1}</p>
              </li>
              <li>
                <i className="fa fa-map">
                  <FaMapMarkedAlt />
                </i>
                <p>{item.address_2}</p>
              </li>
              <li>
                <i className="fa fa-map">
                  <FaMapMarkedAlt />
                </i>
                <p>{item.address}</p>
              </li>
              <li>
                <i className="fa fa-envelope">
                  <MdEmail />
                </i>
                <p>{item.email}</p>
              </li>
              <li>
                <i className="fa fa-phone-alt">
                  <IoCall />
                </i>
                <p>{item.phone}</p>
              </li>
              <li>
                <i className="fa fa-clock">
                  <IoTime />
                </i>
                <p>
                  {item.open} - {item.close}, Mon - Sat
                </p>
              </li>
            </div>
          </div>
        ))}
        <div className="map">
          <iframe
            title="city-stores"
            src="https://www.google.com/maps/d/u/0/embed?mid=12mRM9mBWwDQN8q6G0b-OfnjlLT85PLQ&ehbc=2E312F"
            width="600"
            height="450"
          ></iframe>
        </div>
      </section>

      <section id="form-details">
        <form onSubmit={handleSubmit}>
          <span>LEAVE A MESSAGE</span>
          <h2>We love to hear from you</h2>
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="subject"
            placeholder="Subject"
            value={formData.subject}
            onChange={handleChange}
            required
          />
          <textarea
            name="message"
            cols="30"
            rows="10"
            placeholder="Your Message"
            value={formData.message}
            onChange={handleChange}
            required
          />
          <button type="submit" className="normal">
            Submit
          </button>
        </form>
        {loading && <Loader />}
        <ToastContainer position="top-center" />
        <div className="people">
          <div>
            <img src={Logo} alt="" />
            <p>
              <span>City Gamers & Electronics World</span> <br />
              Phone: +260 976276465 <br />
              Email: citygamersworld@gmail.com
            </p>
          </div>
        </div>
      </section>
      <section id="newsletter" className="section-pl section-ml">
        <div className="newstext">
          <h4>Sign Up For Newsletter</h4>
          <p>
            Get E-mail updates about our latest shop and{" "}
            <span> special offers</span>
          </p>
        </div>
        <div className="form">
          <input type="text" placeholder="Your email address" disabled />
          <button className="normal" onClick={handleSoon}>
            Sign Up
          </button>
        </div>
      </section>
    </div>
  );
}
export default Contact;
